import axios from 'src/utils/axios';
import { getMethodProps } from 'src/types/axios.types';
import { isRequestAbortedError } from './isRequestAbortedError';

const getRequest = ({
  url,
  loader,
  successFunction,
  errorFunction,
  customHeader,
}: getMethodProps) => {
  if (loader) {
    loader(true);
  }
  axios
    .get(url, customHeader)
    .then((res) => {
      if (successFunction) {
        successFunction(res);
      }
    })
    .catch((error) => {
      if (isRequestAbortedError(error)) {
        return;
      }
      if (errorFunction) {
        errorFunction(error);
      }
    })
    .finally(() => {
      if (loader) {
        loader(false);
      }
    });
};

export default getRequest;
